import { Observable } from "rxjs";
class webSocketWrapper {
    constructor() {
        this.connect = url => {
            let socket$ = Observable.webSocket({
                url: url
            });
            return socket$;
        };
    }
}
let webSocket = new webSocketWrapper();
export default webSocket;
//# sourceMappingURL=webSocketWrapper.js.map